<template>
  <el-row
    :gutter="20"
    class="w-full text-center"
    align="middle"
    justify="space-between"
    type="flex"
  >
    <el-col :span="6">
      <div
        class="m-1 relative w-[184px] h-[108px] p-1 overflow-hidden inline-block"
        v-loading="loadingVideo"
      >
        <img
          v-if="coverUrl"
          :src="displayCover"
          class="w-full h-full object-cover"
          alt=""
          @error="onCoverError"
        />
      </div>
    </el-col>
    <el-col
      :span="16"
      class="text-[#666]"
    >
      {{ video.videoTitle }}
    </el-col>
    <el-col
      :span="2"
      class="text-[#666]"
    >
      <el-button
        type="text"
        @click="deleteVideo"
        >删除</el-button
      >
    </el-col>
  </el-row>
</template>
<script>
import { getYoutubeThumbnail } from '@/utils/youtubeVideoInfo';
export default {
  props: {
    video: {
      type: Object,
      default: () => ({}),
    },
    index: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      coverFallback: false,
    };
  },
  computed: {
    loadingVideo() {
      return this.video.status === 'loading';
    },
    coverUrl() {
      return this.video.thumbnailUrl || (this.video.videoId ? getYoutubeThumbnail(this.video.videoId) : '');
    },
    displayCover() {
      if (this.coverFallback && this.video.videoId) {
        return getYoutubeThumbnail(this.video.videoId);
      }
      return this.coverUrl;
    },
  },
  watch: {
    'video.thumbnailUrl'() {
      this.coverFallback = false;
    },
    'video.videoId'() {
      this.coverFallback = false;
    },
  },
  methods: {
    onCoverError() {
      if (!this.coverFallback && this.video.videoId) {
        this.coverFallback = true;
      }
    },
    deleteVideo() {
      this.$emit('deleteVideo', this.index);
    },
  },
};
</script>
<style lang="scss" scoped></style>
